import apiClient from '../client';
const ENDPOINT = '/documents';

export const documentsApi = {
    getList: ({ page = 1, pageSize = 10, sortBy = '-id', filter = {} }) =>
        apiClient.get(ENDPOINT, { params: { page, pageSize, sortBy, filter } }),
    create: (payload) => apiClient.post(ENDPOINT, payload)
};
